import { Cart } from '../services/cart/cart-api.service';
import { Category } from '../../shared/services/common-api.service';
import { HeaderConfigurations } from '../interfaces/store-configuration.interface';

/**
 * Creates a safe fallback Cart object with empty cart_items array
 * This prevents runtime errors when cart is null or undefined
 */
export function createEmptyCart(): Cart {
    return {
        id: '',
        cart_items: [],
        seller_company: {} as any,
        buyer_company: {} as any,
        total_items: 0,
        gst_amount: 0,
        subtotal: 0,
        discount_amount: 0,
        discount_percentage: 0,
        cart_total: 0,
        total_savings: 0,
        cashback_points: 0,
        is_active: false,
        is_current: false,
        is_archived: false,
        initialized_by_admin: false,
        has_new_version: false,
        tax: {}
    } as Cart;
}

/**
 * Safely sets cart with fallback if cart is null or has no cart_items
 */
export function safeCartSetter(cart: Cart | null): Cart {
    return (cart && cart.cart_items) ? cart : createEmptyCart();
}

/**
 * Safely sets categories with fallback to empty array
 */
export function safeCategoriesSetter(categories: Category[] | null): Category[] {
    return categories || [];
}

/**
 * Safely sets header configurations with fallback to empty object
 */
export function safeHeaderConfigurationsSetter(config: HeaderConfigurations | null): HeaderConfigurations {
    return config || {} as HeaderConfigurations;
}

/**
 * Safely sets logo with fallback to empty string
 */
export function safeLogoSetter(logo: string | null): string {
    return logo || '';
}
